import Vue from 'vue'

const THEME_KEY = 'builder_theme'
const TRANSITION_CLASS = 'theme-transition'
const TRANSITION_MS = 420

function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
}

function fallbackTransition(apply) {
    const root = document.documentElement
    root.classList.add(TRANSITION_CLASS)
    apply()
    setTimeout(() => root.classList.remove(TRANSITION_CLASS), TRANSITION_MS)
}

async function applyWithTransition(apply, origin) {
    if (typeof document.startViewTransition !== 'function' || reducedMotion()) return fallbackTransition(apply)

    const x = origin && origin.x != null ? origin.x : window.innerWidth / 2
    const y = origin && origin.y != null ? origin.y : 0
    const radius = Math.hypot(Math.max(x, window.innerWidth - x), Math.max(y, window.innerHeight - y))

    const transition = document.startViewTransition(async () => {
        apply()
        await Vue.nextTick()
    })

    try {
        await transition.ready
        const root = document.documentElement
        root.style.setProperty('--theme-reveal-x', `${x}px`)
        root.style.setProperty('--theme-reveal-y', `${y}px`)
        const reveal = root.animate(
            { '--theme-reveal-radius': ['0px', `${radius}px`] },
            { duration: TRANSITION_MS, easing: 'cubic-bezier(.4, 0, .2, 1)', fill: 'forwards', pseudoElement: '::view-transition-new(root)' }
        )
        transition.finished.then(() => {
            reveal.cancel()
            root.style.removeProperty('--theme-reveal-x')
            root.style.removeProperty('--theme-reveal-y')
        }).catch(() => {})
    } catch (e) {
        return
    }
}

export function setThemeDark(vuetify, dark, origin) {
    applyWithTransition(() => {
        if (vuetify && vuetify.theme) vuetify.theme.dark = dark
    }, origin)
    try {
        localStorage.setItem(THEME_KEY, dark ? 'dark' : 'light')
    } catch (e) {
        return
    }
}

export function toggleTheme(vuetify, origin) {
    const next = !(vuetify && vuetify.theme && vuetify.theme.dark)
    setThemeDark(vuetify, next, origin)
    return next
}

export function isThemeDark(vuetify) {
    return !!(vuetify && vuetify.theme && vuetify.theme.dark)
}
